import React from 'react';

export const PhoneIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 24, width = 24 }) => (
  <svg width={`${width}px`} height={`${height}px`} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.3 5V5.1L12.8 10.6L10.4 12.2L9.8 12.6L10 13.3C11.1 17.7 14.4 20.9 18.7 22L19.4 22.2L19.8 21.6L21.4 19.2L26.9 21.7H27V27H26.9C20.3 27 14.8 24.9 10.9 21C7.1 17.1 5 11.6 5 5H10.3ZM10.3 4H5C4.5 4 4 4.4 4 5C4 19 13 28 26.9 28C26.9 28 26.9 28 27 28C27.5 28 28 27.5 28 27V21.7C28 21.3 27.7 20.9 27.3 20.8L21.7 18.2C21.6 18.2 21.5 18.2 21.4 18.2C21.1 18.2 20.8 18.4 20.6 18.6L19 21C15 20 12 17 11 13L13.4 11.4C13.8 11.2 13.9 10.7 13.8 10.3L11.2 4.7C11.1 4.3 10.7 4 10.3 4Z"
      fill="black"
    />
  </svg>
);
